import style from '../../components/NevisPasskeysSwissRenamePopup/NevisPasskeysSwissRenamePopup.scss';
import { useCallback } from 'react';
import { setFidoAuthenticators } from '@theme/js/components/main/NevisPasskeysSwiss/server';
import { useOnClose } from '@core/js/components/common/PopupManager';
import { useDispatch } from 'react-redux';
import { FidoAuthenticator, INevisEditPasskeysProps } from '../../types';
import { showNevisPopupAction } from '../../actions';
import { ManagedConfirmationPopup } from '../../../../common/popups/ConfirmationPopup/ConfirmationPopup';

export const useRevokePasskey = async ({
    data,
    fetchPortlet,
    portletType,
    index,
    tkPrefix
} : INevisEditPasskeysProps) => {
    const dispatch = useDispatch();
    const onClose = useOnClose();

    const setFidoAuthRequest = useCallback(async (updatedAuth: FidoAuthenticator[]) => {
        try {
            await setFidoAuthenticators(updatedAuth);
            await fetchPortlet({ type: portletType }, { showLoader: false });
            onClose();
        } catch (error) {
            console.error(error);
        }
    }, [fetchPortlet, onClose, portletType]);

    return useCallback (async () => {
        const updatedAuth: FidoAuthenticator[] = [];
        data?.fidoAuthenticators?.forEach((el: FidoAuthenticator, ind: any) => {
            if (ind !== index) {
                updatedAuth.push(el);
            }
        });

        dispatch(showNevisPopupAction({
            closeAll: false,
            isModal: true,
            className: style.revokePopupContainer,
            title: `${tkPrefix}passkeys.revoke.passkey`,
            content: `${tkPrefix}passkeys.revoke.passkey.content`,
            buttons: [
                {
                    text: `${tkPrefix}passkeys.cancel`,
                    className: style.button,
                    color: 'negative',
                    onClick: onClose
                },
                {
                    onClick: () => setFidoAuthRequest(updatedAuth),
                    text: `${tkPrefix}passkeys.revoke`,
                    className: style.button
                }
            ]
        }, ManagedConfirmationPopup));
    }, [data?.fidoAuthenticators, dispatch, index, onClose, setFidoAuthRequest, tkPrefix]);
};

